/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export enum REGIONS {
  AQ = 'AQ',
  CA = 'CA',
  CH = 'CH',
  DE = 'DE',
  GB = 'GB',
  KR = 'KR',
  NL = 'NL',
  NZ = 'NZ',
  US = 'US',
  ZA = 'ZA',
}

export enum LANGUAGES {
  de = 'de',
  en = 'en',
  fr = 'fr',
  it = 'it',
  ko = 'ko',
  nl = 'nl',
}

export enum LOCALES {
  de_ch = 'de-CH',
  de_de = 'de-DE',
  en_aq = 'en-AQ',
  en_ca = 'en-CA',
  en_ch = 'en-CH',
  en_de = 'en-DE',
  en_gb = 'en-GB',
  en_kr = 'en-KR',
  en_nl = 'en-NL',
  en_nz = 'en-NZ',
  en_us = 'en-US',
  en_za = 'en-ZA',
  fr_ca = 'fr-CA',
  fr_ch = 'fr-CH',
  it_ch = 'it-CH',
  ko_kr = 'ko-KR',
  nl_nl = 'nl-NL',
}

export enum DOMAINS {
  aq = '.aq',
  ca = '.ca',
  ch = '.ch',
  de = '.de',
  uk = '.co.uk',
  kr = '.kr',
  nl = '.nl',
  nz = '.co.nz',
  com = '.com',
  za = '.co.za',
}

export enum CURRENCY_CODE_FORMAT {
  de_ch = 'CHF',
  de_de = 'EUR',
  en_aq = 'USD',
  en_ca = 'CAD',
  en_ch = 'CHF',
  en_de = 'EUR',
  en_gb = 'GBP',
  en_nl = 'EUR',
  en_nz = 'NZD',
  en_us = 'USD',
  en_kr = 'KRW',
  en_za = 'ZAR',
  fr_ca = 'CAD',
  fr_ch = 'CHF',
  it_ch = 'CHF',
  ko_kr = 'KRW',
  nl_nl = 'EUR',
}

export enum MONEY_FORMAT {
  de_ch = 'CHF',
  de_de = '€EU',
  en_aq = '$US',
  en_ca = '$CA',
  en_ch = 'CHF',
  en_de = '€EU',
  en_gb = 'GB£',
  en_nl = '€EU',
  en_nz = 'NZ$',
  en_us = '$US',
  en_kr = 'KRW',
  en_za = 'ZAR',
  fr_ca = 'CA$',
  fr_ch = 'CHF',
  it_ch = 'CHF',
  ko_kr = 'KRW',
  nl_nl = '€EU',
}

export const CURRENCY_PREFIX = {
  [LOCALES.de_ch]: 'CHF',
  [LOCALES.de_de]: '€',
  [LOCALES.en_aq]: '$',
  [LOCALES.en_ca]: '$',
  [LOCALES.en_ch]: 'CHF',
  [LOCALES.en_de]: '€',
  [LOCALES.en_gb]: '£',
  [LOCALES.en_nl]: '€',
  [LOCALES.en_nz]: 'NZD',
  [LOCALES.en_us]: '$',
  [LOCALES.en_kr]: 'KRW',
  [LOCALES.en_za]: 'ZAR',
  [LOCALES.fr_ca]: '$',
  [LOCALES.fr_ch]: 'CHF',
  [LOCALES.it_ch]: 'CHF',
  [LOCALES.ko_kr]: 'KRW',
  [LOCALES.nl_nl]: '€',
};

export type LocaleData = {
  code: LOCALES;
  region: REGIONS;
  language: LANGUAGES;
  moneyFormat?: MONEY_FORMAT;
  currencyCodeFormat?: CURRENCY_CODE_FORMAT;
};

export type SupportedReadableRegions = {
  AQ: string;
  CA: string;
  CH: string;
  DE: string;
  GB: string;
  KR: string;
  NL: string;
  NZ: string;
  US: string;
  ZA: string;
};

export type SupportedReadableLanguages = {
  de?: string;
  en?: string;
  fr?: string;
  it?: string;
  ko?: string;
  nl?: string;
};
